import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function Hero() {
  return <section className="relative overflow-hidden bg-mint-light pt-20 pb-16 md:pt-32 md:pb-24" data-id="element-104">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_left,_var(--tw-gradient-stops))] from-white/40 via-transparent to-transparent pointer-events-none" data-id="element-105" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-106">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-107">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left space-y-8" data-id="element-108">
            <div className="space-y-4" data-id="element-109">
              <span className="inline-block py-1 px-3 rounded-full bg-mint-dark/20 text-mint-dark font-semibold text-sm uppercase tracking-wider" data-id="element-110">
                Para madres y padres agotados
              </span>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-charcoal" data-id="element-111">
                Deja de gritar y empieza a conectar:{' '}
                <span className="text-gold block mt-2" data-id="element-112">
                  El Kit de Emergencia para el Caos Parental
                </span>
              </h1>
            </div>

            <p className="text-lg sm:text-xl text-charcoal-light leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-113">
              Recupera tu calma en 60 segundos y rompe el ciclo de
              "Grito-Culpa-Arrepentimiento" con el Método de Intercambio de
              Amígdala.
            </p>

            <div className="pt-4 flex justify-center lg:justify-start" data-id="element-114">
              <CTAButton data-id="element-115" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-116">
            <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full transform -translate-y-10 scale-90" data-id="element-117" />
            <img src="https://cdn.magicpatterns.com/uploads/gAQTXyZ31dUDpJmM5dMYfj/El_Kit_de_Primeros_Auxilios_Emocionales.png" alt="El Kit de Primeros Auxilios Emocionales - Mockup en dispositivos" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-2xl" data-id="element-118" />
          </motion.div>
        </div>
      </div>
    </section>;
}